import { alpha, Theme } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";

import { getRankColor } from "../helpers";

function getRowColor(
  type: "text" | "background" | "border",
  isUser: boolean,
  theme: Theme,
  rank?: number
) {
  if (isUser)
    return type === "background"
      ? alpha(theme.palette.secondary.main, 0.2)
      : theme.palette.secondary.main;
  if (type === "border") return "transparent";
  if (type === "text" && rank) return getRankColor(rank);
  return type === "background" ? "#ffffff" : theme.palette.text.primary;
}

export const useStyles = makeStyles<{ isUser: boolean; rank: number }>()(
  (theme, { isUser, rank }) => ({
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      gap: theme.spacing(2),
      padding: theme.spacing(2.5, 4),
      backgroundColor: getRowColor("background", isUser, theme),
      overflowX: "hidden",
      color: getRowColor("text", isUser, theme),
      borderBottom: "1px solid #DADADA",
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
      },
    },
    contentGroup: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    userDetailsContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(5),
      cursor: "pointer",
    },
    avatarContainer: {
      position: "relative",
    },
    avatar: {
      display: "flex",
      width: 46,
      height: 46,
    },
    subscriptionIcon: {
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    userDetails: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(0.5),
    },
    username: {
      position: "relative",
      fontSize: "0.75rem !important",
      fontWeight: 700,
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    rank: {
      width: "3em",
      display: "flex",
      fontSize: "1.63rem",
      justifyContent: "center",
      [theme.breakpoints.down("md")]: {
        width: "2em",
        fontSize: "1.25rem",
      },
    },
    medal: {
      fontSize: 40,
      color: getRankColor(rank),
    },
    rankLabel: {
      fontSize: "1.63rem",
      fontWeight: 700,
    },
    resultsDetail: {
      fontSize: "0.63rem",
      fontWeight: 500,
      color: "#767676",
    },
    score: {
      fontSize: "1.63rem",
      fontWeight: 700,
      color: getRowColor("text", isUser, theme, rank),
      [theme.breakpoints.down("md")]: {
        fontSize: "1.25rem",
      },
    },
    timeTaken: {
      fontSize: "0.85rem",
      fontWeight: 700,
      alignSelf: "flex-end",
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down("md")]: {
        fontSize: "0.7rem",
        marginBottom: theme.spacing(0.5),
      },
    },
  })
);
